// API helper for the floating employee feedback launcher (FeedbackLauncher.tsx).
//
// The submission is filed in Nexus (the portal stores nothing), so the response
// carries the reference number the reporter cites — show it to them.

import { api } from './client.js';

export type FeedbackScreenshotPayload = {
  filename: string;
  mime_type: string;
  content_base64: string;
};

export type SubmitFeedbackRequest = {
  category: string;
  summary: string;
  description: string;
  additional_notes?: string | null;
  module?: string | null;
  page_name?: string | null;
  page_url?: string | null;
  screenshots?: FeedbackScreenshotPayload[];
};

export type SubmitFeedbackResponse = {
  id: string;
  feedback_number: string | null;
  status: string | null;
};

export async function submitFeedback(
  body: SubmitFeedbackRequest
): Promise<SubmitFeedbackResponse> {
  const res = await api.post<SubmitFeedbackResponse>('/feedback', body);
  return res.data;
}
